import {get, isNil, isEmpty} from 'lodash'
import {getPartPackFor, getPartPacks, updatePartPacksFor} from 'helpers/packs'

export const ApplyCostType = {
  APPLY_BASE_COST: {
    id: 0,
    value: 0,
    key: 0,
    label: 'Base Cost of',
  },
  APPLY_MINIMUM_COST: {
    id: 1,
    value: 1,
    key: 1,
    label: 'Minimum Cost of',
  },
}

export const mapCostTypedToOptions = () => {
  return Object.values(ApplyCostType)
}

export const getPartSuppliers = (partPack) => {
  return get(partPack, 'suppliers', [])
}

export const getDefaultPartSupplier = (partPack) => {
  const suppliers = getPartSuppliers(partPack)
  if (isEmpty(suppliers))
    return null

  const defaultPartSupplier = suppliers.find(supplier => supplier.default === true)
  return isNil(defaultPartSupplier)
      ? suppliers[0]
      : defaultPartSupplier
}

export const getPartSupplierFor = (part, partPackId, partSupplierId) => {
  const partPacks = get(part, 'packs', [])
  const partPack = getPartPackFor(partPackId, partPacks)
  const partSuppliers = getPartSuppliers(partPack)
  return partSuppliers.find(partSupplier => partSupplier.id === partSupplierId)
}

export const getPartSupplierForCompany = (part, partPackId, companyId) => {
  const partPacks = get(part, 'packs', [])
  const partPack = getPartPackFor(partPackId, partPacks)
  const partSuppliers = getPartSuppliers(partPack)
  return partSuppliers.find(partSupplier => partSupplier.companyId === companyId)
}

export const getPartSupplierForPurchaseOrderItem = (purchaseOrderItem, purchaseOrder) => {
  const partPack = get(purchaseOrderItem, 'partPack', null)
  if (isNil(partPack))
    return null

  const partSuppliers = get(purchaseOrderItem, 'partPack.suppliers', [])
  return partSuppliers.find(partSupplier => partSupplier.companyId === purchaseOrder.companyId)
}

export const addPartSupplierToPart = (part, partPackId, partSupplier, isComplexPricingEnabled) => {
  const updatedPart = {...part}
  const partPacks = getPartPacks(updatedPart, isComplexPricingEnabled)
  const partPack = getPartPackFor(partPackId, partPacks)
  const partSuppliers = getPartSuppliers(partPack)

  if (get(partSupplier, 'default', false)) {
    partSuppliers.map(supplier => supplier.default = false)
  } else {
    const defaultPartSupplier = getDefaultPartSupplier(partPack)
    if (isNil(defaultPartSupplier)) {
      partSupplier.default = true
    } else {
      partSuppliers.map(supplier => supplier.default = supplier.id === defaultPartSupplier.id)
    }
  }

  partSuppliers.push(partSupplier)
  partPack.suppliers = partSuppliers
  updatedPart.packs = updatePartPacksFor(partPackId, partPacks, partPack)
  return updatedPart
}

export const updatePartSupplierFor = (part, partPackId, partSupplier, isComplexPricingEnabled) => {
  const updatedPart = {...part}
  const partPacks = getPartPacks(updatedPart, isComplexPricingEnabled)
  const partPack = getPartPackFor(partPackId, partPacks)
  const partSuppliers = getPartSuppliers(partPack)

  if (get(partSupplier, 'default', false)) {
    partSuppliers.map(supplier => supplier.default = (supplier.id === partSupplier.id))
  } else {
    const defaultPartSupplier = partSuppliers.find(supplier => supplier.default === true)
    if (isEmpty(defaultPartSupplier) || defaultPartSupplier.id === partSupplier.id) {
      partSupplier.default = true
    }
  }

  partPack.suppliers = partSuppliers.map(supplier => {
    return supplier.id === partSupplier.id
        ? partSupplier
        : supplier
  })

  const newDefaultPartSupplier = partSuppliers.find(supplier => !isNil(supplier.defaultSupplierId))
  if (!isNil(newDefaultPartSupplier)) {
    partPack.suppliers = partSuppliers.map(supplier => {
      if (supplier.id === newDefaultPartSupplier.id) {
        delete newDefaultPartSupplier.defaultSupplierId
        return {
          ...newDefaultPartSupplier,
          default: true,
        }
      }

      return {
        ...supplier,
        default: false,
      }
    })
  }

  updatedPart.packs = updatePartPacksFor(partPackId, partPacks, partPack)
  return updatedPart
}

export const deletePartSupplierFor = (part, partPackId, partSupplier, isComplexPricingEnabled) => {
  const updatedPart = {...part}
  const partPacks = getPartPacks(updatedPart, isComplexPricingEnabled)
  const partPack = getPartPackFor(partPackId, partPacks)
  const partSuppliers = getPartSuppliers(partPack)
  partPack.suppliers = partSuppliers.filter(supplier => supplier.id !== partSupplier.id)
  partPack.deletedSuppliers = [partSupplier]
  updatedPart.packs = updatePartPacksFor(partPackId, partPacks, partPack)
  return updatedPart
}
